import './PreviewRemLabel.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import images from '../../assets/images';
import { FaceLabel } from '..';
import { LABEL_SIZE_MAP, PREVIEW } from '../../constants';

/**
 * PreviewRemLabel Component
 * @augments {Component<Props, State>}
 */
class PreviewRemLabel extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { fields } = this.props;

        return (
            <div className={'PreviewRemLabel'}>
                <FaceLabel
                    colors={PREVIEW.COLORS}
                    size={LABEL_SIZE_MAP.REMNANT}
                    partNumber={1}
                    totalParts={1}
                    part={{ id: '00S1O', ogPartId: '00S1O', file_url: images.preview.part }}
                    fields={fields}
                    allowSizeChange={false}
                    barcodeEnabled={false}
                    qrDisabled={false}
                />
            </div>
        );
    }
}

PreviewRemLabel.defaultProps = {
    showEmpty: false,
    checklist: PREVIEW.CHECKLIST
};

PreviewRemLabel.propTypes = {
    size: PropTypes.string.isRequired,
    checklist: PropTypes.shape(),
    allowSizeChange: PropTypes.bool,
    fields: PropTypes.array.isRequired,
    barcodeEnabled: PropTypes.bool,
    qrDisabled: PropTypes.bool
};


export default PreviewRemLabel;
